import { useEffect, useState } from "react";
import { Box, Button, Image, Text, useDisclosure } from "@chakra-ui/react";
import { getApi } from "common/services/api";
import { HasAccess } from "../../../../common/utils/accessUtils";
import CommonCheckTable from "common/components/checktable";
import { DeleteIcon, SearchIcon } from "@chakra-ui/icons";
import EditTask from "../../components/jobProfile/editDepartment";
import { useLocation, useNavigate } from "react-router-dom";
import CommonDeleteModel from "common/components/commonDeleteModel";
import JobProfileAdvanceSearch from "../../components/jobProfile/JobProfileAdvanceSearch";
import { deleteApi } from "common/services/api";
import JobProfileView from "../../components/jobProfile/JobProfileView";
import { toast } from "react-toastify";
import AddJobProfile from "../../components/jobProfile/addJobProfile";
import viewIcon from "common/assets/img/viewIcon.png";
import deleteIcon from "common/assets/img/deleteIcon.png";
import editIcon from "common/assets/img/editIcon.png";
import { constant } from "common/constant";
import DateFormatter from "common/utils/dateFormater";
import { globalStyles } from "common/theme/styles";
import CustomStatus from "common/components/status/CustomStatus";
import Rating from "services/Recruit/components/Rating/Rating";
import { JobApplicationData } from "services/Recruit/data/jobApplicationData";
import { recruitConstant } from "services/Recruit/constant";
import StatusDropdown from "common/components/statusDropdown";
import { putApi } from "common/services/api";
import CustomStatusDropdown from "services/Recruit/components/CustomStatusDropdown/CustomStatusDropdown";
import { customDropDownData } from "services/Recruit/data/recruitData";

const Application = () => {
  const title = recruitConstant.createApplications;
  const [action, setAction] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [edit, setEdit] = useState(false);
  const [eventView, setEventView] = useState(false);
  const [id, setId] = useState("");
  const [selectedId, setSelectedId] = useState();
  const [selectedValues, setSelectedValues] = useState([]);
  const [advanceSearch, setAdvanceSearch] = useState(false);
  const [getTagValuesOutSide, setGetTagValuesOutside] = useState([]);
  const [searchboxOutside, setSearchboxOutside] = useState("");
  const [deleteMany, setDeleteMany] = useState(false);
  const [deleteModel, setDelete] = useState(false);
  const [isImportLead, setIsImportLead] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [displaySearchData, setDisplaySearchData] = useState(false);
  const [searchedData, setSearchedData] = useState([]);
  const [tableData, setTableData] = useState(JobApplicationData);
  const [menuSelectedDeleteItem, setMenuSelectedDeleteItem] = useState([]);
  const colors = globalStyles.colors;
  const [permission, leadAccess, contactAccess] = HasAccess([
    "Tasks",
    "Leads",
    "Contacts",
  ]);
  const navigate = useNavigate();

  const location = useLocation();
  const state = location.state;

  const actionHeader = {
    Header: recruitConstant.actions,
    isSortable: false,
    center: true,
    cell: ({ row }) => (
      <Text fontSize="md" fontWeight="900" textAlign={"center"}>
        <Box className="actionCellContainer">
          {/* {permission?.update && (
            <Image
              onClick={() =>
                navigate(`/recruit/applicationCreate/${row?.values?.id}`)
              }
              src={viewIcon}
              h={"20px"}
              w={"20px"}
            />
          )} */}
          {permission?.view && (
            <Image
              onClick={() =>
                navigate(`/recruit/applicationCreate/${row?.values?.id}`)
              }
              src={editIcon}
              h={"20px"}
              w={"20px"}
            />
          )}
          {permission?.delete && (
            <Image
             onClick={() => {
              setDeleteMany(true);
              setSelectedValues([row?.values?.id]); 
            }}
              src={deleteIcon}
              h={"20px"}
              w={"20px"}
            />
          )}
        </Box>
      </Text>
    ),
  };
 
  const tableColumns = [
    {
      Header: "#",
      accessor: "id",
      isSortable: false,
      width: 5,
    },
    {
      Header: recruitConstant.applicationName,
      accessor: "name",
      type: "text",
      formikType: "",
      cell: (cell) => (
        <div className="link">
          <Text color={colors.cta["100"]}>{cell?.value}</Text>
        </div>
      ),
    },
    {
      Header: recruitConstant.currentLocation,
      accessor: "location",
      type: "text",
      formikType: "",
      cell: (cell) => (
        <Box>
          <div className="selectOpt">
            <Text>{cell?.value}</Text>
          </div>
        </Box>
      ),
    },
    {
      Header: recruitConstant.status,
      accessor: "status",
      type: "select",
      formikType: "",
      cell: (cell) => (
        <div>
          <CustomStatusDropdown
            statusOptions={customDropDownData}
            defaultStatus={recruitConstant.completed} 
          />

        </div>
      ),
    },
    {
      Header: recruitConstant.applicationId,
      accessor: "applicationId",
      type: "text",
      formikType: "",
      cell: (cell) => (
        <Box>
          <div className="selectOpt">
            <Text>{cell?.value}</Text>
          </div>
        </Box>
      ),
    },
    {
      Header: recruitConstant.postingTitle,
      accessor: "job_name",
      type: "text",
      formikType: "",
      cell: (cell) => (
        <div className="selectOpt">
          <Text>{cell?.value}</Text>
        </div>
      ),
    },

    {
      Header: recruitConstant.date,
      accessor: "created_at",
      type: "text",
      formikType: "",
      cell: (cell) => (
        <Box>
          <Text me="10px" fontSize="sm" fontWeight="700">
            <span>{DateFormatter(cell?.value)}</span>
          </Text>
        </Box>
      ),
    },

    {
      Header: recruitConstant.rating,
      accessor: "rating",
      type: "text",
      formikType: "",
      cell: (cell) => (
        <Box>
          <Rating value={cell?.value} />
        </Box>
      ),
    },
    ...(permission?.update || permission?.view || permission?.delete
      ? [actionHeader]
      : []),
  ];
  const setStatusData = async (cell, e) => {
    try {
      let response = await putApi(
        `api/task/changeStatus/${cell?.row?.original?._id}`,
        { status: e }
      );
      if (response.status === 200) {
        setAction((pre) => !pre);
        toast.success(recruitConstant.statusUpdated);
      }
    } catch (e) {
      toast.error(recruitConstant.someThingWentWrong);
    } finally {
    }
  };


  const handleDeleteProfile = async (ids) => {
    const updatedTableData = tableData.filter((item) => !ids.includes(item.id));
    setTableData(updatedTableData);
    setSelectedValues([]);
    setDeleteMany(false);
    toast.success(constant.deleteJobAllication);
  };

  const [columns, setColumns] = useState([...tableColumns]);
  const [selectedColumns, setSelectedColumns] = useState([...tableColumns]);

  const dataColumn = tableColumns.filter((item) =>
    selectedColumns.some((column) => column.Header === item.Header)
  );

  return (
    <div>
      <CommonCheckTable
        title={title}
        isLoading={isLoading}
        columnData={columns}
        dataColumn={dataColumn}
        allData={tableData?.[0]?.data || []}
        tableData={tableData?.[0]?.data || []}
        searchDisplay={displaySearchData}
        setSearchDisplay={setDisplaySearchData}
        searchedDataOut={searchedData}
        setSearchedDataOut={setSearchedData}
        tableCustomFields={[]}
        access={permission}
        action={action}
        setAction={setAction}
        selectedColumns={selectedColumns}
        setSelectedColumns={setSelectedColumns}
        isOpen={isOpen}
        onClose={onclose}
        state={state}
        onOpen={onOpen}
        selectedValues={selectedValues}
        setSelectedValues={setSelectedValues}
        setDelete={setDeleteMany}
        AdvanceSearch={
          <Button
            variant="outline"
            className="advance-search-button"
            colorScheme="brand"
            leftIcon={<SearchIcon />}
            mt={{ sm: "5px", md: "0" }}
            size="sm"
            onClick={() => setAdvanceSearch(true)}
          >
            {constant.advanceSearch}
          </Button>
        }
        getTagValuesOutSide={getTagValuesOutSide}
        searchboxOutside={searchboxOutside}
        setGetTagValuesOutside={setGetTagValuesOutside}
        setSearchboxOutside={setSearchboxOutside}
      />

      <CommonDeleteModel
        isOpen={deleteMany}
        onClose={() => setDeleteMany(false)}
        type={recruitConstant.jobApplication}
        handleDeleteData={handleDeleteProfile}
        ids={selectedValues}
      />
    </div>
  );
};

export default Application;
